import { apiSlice } from "../";
import { getToken } from "shared/utils/getToken";

export interface EtapaPadrao {
    idEtapaPadrao: number,
    nome: string,
    idEtapa: number,
    ordem: number,
    peso: number
}

export interface EtapaPadraoCreate {
    idEtapa: number,
    ordem: number,
    peso: number
}

export interface EtapaPadraoUpdateRequest {
    idEtapaPadrao: number,
    etapaPadrao: {
        ordem: number,
        peso: number
    }
}

const etapaPadraoSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getEtapasPadroes: builder.query<EtapaPadrao[], void>({
            query: () =>({
                url: "etapa-padrao",
                method: "GET",
                headers: {
                    Authorization: `Bearer ${getToken()}`,
                }
            }),
            providesTags: ["EtapasPadrao"]
        }),
        postEtapaPadrao: builder.mutation<void, EtapaPadraoCreate>({
            query: (data) => ({
                url: "etapa-padrao",
                method: "POST",
                headers: {
                    Authorization: `Bearer ${getToken()}`,
                },
                body: {
                    idEtapa: data.idEtapa,
                    ordem: data.ordem,
                    peso: data.peso
                }
            }),
            invalidatesTags: ["EtapasPadrao"]
        }),
        updateEtapaPadrao: builder.mutation<void, EtapaPadraoUpdateRequest>({
            query: (data) => ({
                url: `etapa-padrao/${data.idEtapaPadrao}`,
                method: "PUT",
                headers: {
                    Authorization: `Bearer ${getToken()}`,
                },
                body: {
                    ordem: data.etapaPadrao.ordem,
                    peso: data.etapaPadrao.peso
                }
            }),
            invalidatesTags: ["EtapasPadrao"]
        }),
        deleteEtapaPadrao: builder.mutation<void, number>({
            query: (id) => ({
                url: `etapa-padrao/${id}`,
                method: "DELETE",
                headers: {
                    Authorization: `Bearer ${getToken()}`,
                },
            }),invalidatesTags: ["EtapasPadrao"]
        })
    })
})

export const {
    useGetEtapasPadroesQuery,
    usePostEtapaPadraoMutation,
    useUpdateEtapaPadraoMutation,
    useDeleteEtapaPadraoMutation
} = etapaPadraoSlice

